<template>
  <main role="main" class="py-4">
    <b-container>
      <h4>{{ $t("updateSubPlan") }}</h4>

      <div v-if="isLoading" class="text-center py-5"><b-spinner type="glow"/></div>

      <b-form v-if="originalPlan" class="mt-4 max-width-700" @submit.prevent="submitForm">
        <!--<b-form-row>
          <b-form-group class="col-lg-6">
            <template v-slot:label>
              Tên gói cước <span class="text-danger">*</span>
            </template>
            <b-form-input type="text" required minlength="2" maxlength="20" v-model="name" />
          </b-form-group>
          <b-form-group class="col-lg-6" label="Loại gói cước">
            <b-form-select v-model="packageType" :options="packageTypeOptions" />
          </b-form-group>
        </b-form-row>-->

        <b-form-row>
          <b-form-group class="col-lg-6">
            <template v-slot:label>
              {{ $t("subPlanCode") }}
            </template>
            <b-form-input type="text" minlength="1" maxlength="30" v-model="code" />
          </b-form-group>
          <b-form-group class="col-lg-6">
            <template v-slot:label>
              {{ $t("subPlanName") }} <span class="text-danger">*</span>
            </template>
            <b-form-input type="text" required minlength="2" maxlength="50" v-model="name" />
          </b-form-group>
        </b-form-row>

        <b-form-row>
          <b-form-group class="col-lg-6">
            <template v-slot:label>
              {{ $t("maximumNumberOfParticipantsInMeeting") }} <span class="text-danger">*</span>
            </template>
            <b-form-input required type="number" min="2" max="1000" v-model="maximumNumberOfParticipantsInMeeting" />
          </b-form-group>
          <b-form-group class="col-lg-6" label="." label-class="text-white">
            <b-form-radio-group buttons button-variant="outline-primary" class="w-100"
                                v-model="maximumNumberOfParticipantsInMeeting"
                                :options="maximumNumberOfParticipantsInMeetingOptions" />
          </b-form-group>
        </b-form-row>

        <b-form-row>
          <b-form-group class="col-lg-6">
            <template v-slot:label>
              {{ $t("numberOfConcurrentMeetings") }} <span class="text-danger">*</span>
            </template>
            <b-form-input required type="number" min="1" max="100" v-model="maxConcurrentMeetings" />
          </b-form-group>
          <b-form-group class="col-lg-6" label="." label-class="text-white">
            <b-form-radio-group buttons button-variant="outline-primary" class="w-100"
                                v-model="maxConcurrentMeetings" :options="maxConcurrentMeetingsOptions" />
          </b-form-group>
        </b-form-row>

        <b-form-row>
          <b-form-group class="col-lg-6">
            <template v-slot:label>
              {{ $t("maximumLengthOfOneMeeting") }} ({{ $t("minutes") }}) <span class="text-danger">*</span>
            </template>
            <b-form-input required type="number" min="1" max="1440" v-model="maxMeetingDuration" />
          </b-form-group>
          <b-form-group class="col-lg-6" label="." label-class="text-white">
            <b-form-radio-group buttons button-variant="outline-primary" class="w-100"
                                v-model="maxMeetingDuration" :options="maxMeetingDurationOptions" />
          </b-form-group>
        </b-form-row>

        <b-form-row>
          <b-form-group class="col-lg-6">
            <template v-slot:label>
              {{ $t("numberOfMeetingsPerMonth") }} <span class="text-danger">*</span>
            </template>
            <b-form-input required type="number" min="1" max="100000" v-model="numberOfMeetingsPerMonth" />
          </b-form-group>
          <b-form-group class="col-lg-6" label="." label-class="text-white">
            <b-form-radio-group buttons button-variant="outline-primary" class="w-100"
                                v-model="numberOfMeetingsPerMonth" :options="numberOfMeetingsPerMonthOptions" />
          </b-form-group>
        </b-form-row>

        <b-form-row>
          <b-form-group class="col-lg-6">
            <template v-slot:label>
              {{ $t("servicePrice") }} (VND) <span class="text-danger">*</span>
            </template>
            <b-form-input type="number" required min="0" max="1000000000" v-model="price"/>
          </b-form-group>
          <b-form-group class="col-lg-3">
            <template v-slot:label>
              {{ $t("subscriptionLength") }} <span class="text-danger">*</span>
            </template>
            <b-form-input type="number" required min="1" max="32" v-model="numberOfDaysUsage"/>
          </b-form-group>
          <b-form-group class="col-lg-3" :label="$t('unitTime')">
            <b-form-select required :options="unitTimes" v-model="unitTime" />
          </b-form-group>
        </b-form-row>

        <b-form-row class="mt-2 mb-4">
          <b-form-group class="col-lg-6" :label="$t('packageType')">
            <b-form-select v-model="packageType" :options="packageTypeOptions" />
          </b-form-group>
          <b-form-group class="col-lg-6" :label="$t('activeStatus')">
            <b-form-radio-group required :options="activeOptions" v-model="active" />
          </b-form-group>
        </b-form-row>

        <b-form-row class="mt-2 mb-4">
          <b-form-group class="col-lg-6" >
            <template v-slot:label>{{ $t('packageStatus') }} <span class="text-danger">*</span></template>
            <b-form-select v-model="status" :options="packageStatusOptions" required>
            </b-form-select>
          </b-form-group>
        </b-form-row>

        <div class="text-center">
          <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("saveChanges") }}</b-button>
          <!--<b-button type="button" @click="goBackToList">Test go back</b-button>-->
        </div>
      </b-form>

    </b-container>
  </main>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import * as subscriptionPlanService from "@/service/subscriptionPlanService";
  import BaseComponent from "@/components/BaseComponent";

  @Component
  export default class EditSubscriptionPlan extends BaseComponent {

    id: number;
    originalPlan = null;

    name = "";
    code = "";
    packageTypeOptions = [];
    packageType = "Basic";
    status:number = 1;
    packageStatusOptions = [
    { value: 1, text:  this.$t("demo").toString() },
    { value: 2, text:  this.$t("trial").toString() },
    { value: 3, text:  this.$t("testing").toString() },
    { value: 4, text:  this.$t("official").toString() },
    ];

    maximumNumberOfParticipantsInMeetingOptions = [ 50, 100, 300, 500, 1000 ];
    maximumNumberOfParticipantsInMeeting: number = null;

    maxConcurrentMeetingsOptions = [ 10, 20, 50, 100 ];
    maxConcurrentMeetings: number = null;

    maxMeetingDurationOptions = [
      { text: "2 " + this.$t("hours").toString(), value: 120 },
      { text: "4 " + this.$t("hours").toString(), value: 240 },
      { text: "24 " + this.$t("hours").toString(), value: 1440 }
    ];
    maxMeetingDuration: number = null;

    numberOfMeetingsPerMonthOptions = [ 100, 300, 500, 1000 ];
    numberOfMeetingsPerMonth: number = null;

    price: number = null;

    numberOfDaysUsageOptions = [
      { text: "1 " + this.$t("months").toString(), value: 1 },
      { text: "3 " + this.$t("months").toString(), value: 3 },
      { text: "6 " + this.$t("months").toString(), value: 6 },
      { text: "12 " + this.$t("months").toString(), value: 12 },
      { text: "24 " + this.$t("months").toString(), value: 24 },
      { text: "36 " + this.$t("months").toString(), value: 36 },
    ];
    numberOfDaysUsage = 1;

    unitTimes = [
      { text: this.$t("days").toString(), value: "day" },
      { text: this.$t("weeks").toString(), value: "week" },
      { text: this.$t("months").toString(), value: "month" },
      { text: this.$t("years").toString(), value: "year" }
    ];

    unitTime = "month";

    coreImplNameOptions = [
      { text: "BBB (BigBlueButton)", value: "bbb" },
      { text: "Zoom", value: "zoom" },
    ];
    coreImplName = "bbb";

    activeOptions = [
      { text: this.$t("yes").toString(), value: 1 },
      { text: this.$t("no").toString(), value: 0 },
    ];
    active = 1;

    isLoading = false;
    isSubmitting = false;

    mounted() {
      this.id = +this.$route.params.id;
      this.fetchPlan();
      this.fetchPlanTypeList();
    }

    async fetchPlanTypeList() {
      try {
        this.packageTypeOptions = await subscriptionPlanService.getPlanTypeList();

      } catch (e) {
        this.toastError(e);
      }
    }

    async fetchPlan() {
      try {
        this.isLoading = true;
        const plan = await subscriptionPlanService.getPackageDetail(this.id);

        this.name = plan.name;
        this.packageType = plan.packageType;
        this.status= plan.status,
        this.code = plan.code;
        this.maximumNumberOfParticipantsInMeeting = plan.maximumNumberOfParticipantsInMeeting;
        this.maxConcurrentMeetings = plan.numberOfConcurrentMeetings;
        this.maxMeetingDuration = plan.maximumLengthOfOneMeeting;
        this.numberOfMeetingsPerMonth = plan.numberOfMeetingsPerMonth;
        this.numberOfDaysUsage = plan.numberOfDaysUsage;
        this.price = plan.price;
        // this.coreImplName = plan.coreImplName?.toLowerCase();
        this.active = plan.active;

        this.originalPlan = plan;
        this.unitTime = plan.unitTime;

      } catch (e) {
        this.toastError(e);

      } finally {
        this.isLoading = false;
      }
    }

    async submitForm() {
      try {
        this.isSubmitting = true;

        const data = {
          id: this.id,
          name: this.name,
          packageType: this.packageType,
          status: this.status,
          maximumNumberOfParticipantsInMeeting: +this.maximumNumberOfParticipantsInMeeting,
          numberOfConcurrentMeetings: +this.maxConcurrentMeetings,
          maximumLengthOfOneMeeting: +this.maxMeetingDuration,
          numberOfMeetingsPerMonth: +this.numberOfMeetingsPerMonth,
          price: +this.price,
          numberOfDaysUsage: +this.numberOfDaysUsage,
          coreImplName: this.coreImplName,
          active: this.active,
          createdBy: this.originalPlan.createdBy,
          createdTime: this.originalPlan.createdTime,
          unitTime: this.unitTime,
          code: this.code
        };

        await subscriptionPlanService.updatePackage(data);
        this.goBackToList();

      } catch (e) {
        this.toastError(e);

      } finally {
        this.isSubmitting = false;
      }
    }

    goBackToList() {
      this.$router.push("/subscription-plans");
      this.toastSuccessDelay(this.$t("updateSubPlanSuccessful").toString());
    }

  }
</script>
